import React, { useState, useEffect, useRef, Fragment } from "react";
import arrow from "../../assets/icons/down arrow.svg";
import moment from "moment";
import AppDatePicker from "../../components/Common/AppDatePicker";
import cross from "../../assets/icons/x-circle-3.svg";
import calendar from "../../assets/icons/calendar.svg";
import cross2 from "../../assets/icons/x-circle.svg";
import SupplierIcon from "../../assets/icons/Suppliers.svg";
import Calendar from "../../assets/icons/Calendar3.svg";
import { useDispatch, useSelector } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  FetchTeamProjectWise,
  FetchTeams,
  FetchUsersByCompany,
  FetchEquipmentByWeek,
  AddEquipmentToTask,
  changeProjectTab,
} from "../../redux/actions/action";
import AddWork from "./AddWork";
import simpleRequest from "../../utils/helpers/simpleRequest";
import { ReactFlow, Controls, Background } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import Plusicon from "../../assets/icons/Plus.svg";
import { SingleWorkLine } from "./teamComp";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const Team = () => {
  const dispatch = useDispatch();
  const projectId = window.localStorage.getItem("projectid");
  const companyId = window.localStorage.getItem("companyid");
  const FetchTeamProjectWiseResponse = useSelector(
    (state) => state.user.FetchTeamProjectWiseResponse
  );
  const FetchUsersByCompanyResponse = useSelector(
    (state) => state.user.FetchUsersByCompany
  );
  const FetchTeamsResponse = useSelector(
    (state) => state.user.FetchTeamsResponse
  );
  const AddTaskToTeamResponse = useSelector(
    (state) => state.user.AddTaskToTeamResponse
  );

  const fetchEquipmentByWeekRes = useSelector(
    (state) => state.user.fetchEquipmentByWeekRes
  );

  const addEquipmentToTaskRes = useSelector(
    (state) => state.user.addEquipmentToTaskRes
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [currentWeek, setCurrentWeek] = useState("");
  const [from, setFrom] = useState();
  const [weeksArray, setWeeksArray] = useState([]);
  const [activeWeekList, setActiveWeekList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [workTasks, setWorkTasks] = useState([]);
  const [activeWeek, setActiveWeek] = useState(null);
  const [activeWeekIndex, setActiveWeekIndex] = useState(null);
  const [showMemberBox, setShowMemberBox] = useState(false);
  const [showSortBy, setShowSortBy] = useState(false);
  const [showVehicle, setShowVehicle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("Employee");
  const [activeTask, setActiveTask] = useState(null);
  const emptyBox = ["", "", "", "", "", "", "", "", "", ""];
  const [taskList, setTaskList] = useState([]);
  const [availableEquipmntData, setAvailableEquipmntData] = useState([]);
  const [isAddWork, setIsAddWork] = useState(false);
  const [taskid2, setTaskid2] = useState("");
  const [selectedAssignees, setSelectedAssignees] = useState([]);

  const fetchWorkList = async () => {
    const resp = await simpleRequest(`/api/User/FetchPlanningWork`, "post", {
      projectid: projectId,
      startingDate: moment(from).startOf("day"),
      endingDate: moment(from).add(63, "days").endOf("day"),
    });
    if (resp?.status === true) {
      const list = new Array();
      resp?.data?.map((item) => {
        let tasks = getTasksPosition(
          activeWeekIndex >= 0 ? activeWeekIndex : undefined,
          activeWeek || undefined,
          activeWeekList || undefined,
          item?.workTasks
        );
        tasks?.length > 0 &&
          list.push({
            ...item,
            workTasks: tasks,
          });
      });
      setWorkTasks([...list]);
      setLoading(false);
    } else setLoading(false);
  };

  const filterTasks = (tasks) => {
    const list = [];
    tasks.map((item) => {
      if (
        (moment(item?.startingDate).isSameOrAfter(from) &&
          moment(item?.startingDate).isSameOrBefore(
            moment(from).add(63, "days")
          )) ||
        (moment(item?.endDate).isSameOrAfter(moment(from)) &&
          moment(item?.endDate).isSameOrBefore(moment(from).add(63, "days")))
      )
        list.push(item);
    });
    return list;
  };

  function getDaysOfWeek(year, weekNumber) {
    var januaryFirst = new Date(year, 0, 1);
    var daysToAdd = (weekNumber - 1) * 7 - januaryFirst.getDay() + 1;
    var startDate = new Date(year, 0, 1 + daysToAdd);

    var days = [];
    for (var i = 0; i < 7; i++) {
      var currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);
      days.push(currentDate);
    }
    setActiveWeekList([...days]);
    return days;
  }

  Date.prototype.getWeek = function () {
    var onejan = new Date(this.getFullYear(), 0, 1);
    var today = new Date(this.getFullYear(), this.getMonth(), this.getDate());
    var dayOfYear = (today - onejan + 86400000) / 86400000;
    return Math.ceil(dayOfYear / 7);
  };

  function getWeekNumber(d) {
    d = new Date(+d);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    var yearStart = new Date(d.getFullYear(), 0, 1);
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    return [d.getFullYear(), weekNo];
  }

  function weeksInYear(year) {
    var d = new Date(year, 11, 31);
    var week = getWeekNumber(d)[1];
    return week == 1 ? 52 : week;
  }

  function getCurrentWeek() {
    const weekStart = moment().startOf("isoWeek");

    const days = [];
    for (let i = 0; i <= 6; i++) {
      days.push(moment(weekStart).add(i, "days"));
    }
    return days;
  }

  const getTasksPosition = (index, week, days, listmain) => {
    if (
      (index !== undefined || index === 0) &&
      week !== undefined &&
      days !== undefined
    ) {
      let list = [...listmain];
      list?.map((task) => {
        let startIndex = days?.findIndex(
          (day) =>
            moment(new Date(day)).format("DD/MM/YYYY") ===
            moment(new Date(task?.startingDate)).format("DD/MM/YYYY")
        );
        let endIndex = days?.findIndex(
          (day) =>
            moment(new Date(day)).format("DD/MM/YYYY") ===
            moment(new Date(task?.endDate)).format("DD/MM/YYYY")
        );
        if (new Date(task?.endDate) < new Date(task?.startingDate))
          return (task["display"] = "none");
        if (startIndex === endIndex && startIndex !== -1 && endIndex !== -1) {
          index = index <= 2 ? index : 2;
          task["display"] = "flex";
          task["left"] = `${((startIndex + index) / 9) * 95.7}%`;
          task["width"] = `${(1 / 9) * 95.7}%`;
          return;
        }
        if (startIndex === -1 && endIndex === -1) task["display"] = "none";
        if (startIndex === -1 && endIndex === -1) {
          let startStatus =
            new Date(moment(days[0]).format("MM/DD/YYYY")) >
            new Date(moment(task?.startingDate).format("MM/DD/YYYY"));
          let endStatus =
            new Date(moment(task?.endDate).format("MM/DD/YYYY")) >
            new Date(moment(days[6]).format("MM/DD/YYYY"));
          if (startStatus && endStatus) {
            index = index <= 2 ? index : 2;
            task["display"] = "flex";
            task["left"] = `${(index / 9) * 95.7}%`;
            task["width"] = `${(7 / 9) * 95.7}%`;
            return;
          }
        }
        if (
          (startIndex !== -1 && endIndex === -1) ||
          (startIndex !== -1 && endIndex === 6)
        ) {
          index = index <= 2 ? index : 2;
          task["display"] = "flex";
          task["left"] = `${((startIndex + index) / 9) * 95.7}%`;
          task["width"] = `${((7 - startIndex) / 9) * 95.7}%`;
          return;
        }
        if (startIndex !== -1 && endIndex !== -1) {
          index = index <= 2 ? index : 2;
          task["display"] = "flex";
          task["left"] = `${((startIndex + index) / 9) * 95.7}%`;
          task["width"] = `${((endIndex - startIndex + 1) / 9) * 95.7}%`;
          return;
        }
        if (startIndex === -1 && endIndex !== -1) {
          index = index <= 2 ? index : 2;
          task["display"] = "flex";
          task["left"] = `${(index / 9) * 95.7}%`;
          task["width"] = `${((endIndex + 1) / 9) * 95.7}%`;
          return;
        }
      });
      return list;
    }
    let tasks = [...listmain];
    tasks?.map((task) => {
      if (new Date(task?.endDate) >= new Date(task?.startingDate)) {
        let days =
          Math.abs(new Date(task?.endDate) - new Date(task?.startingDate)) /
          (1000 * 60 * 60 * 24);
        let width = ((days + 1) / 63) * 95.7;
        // let leftDays =
        //   Math.abs(new Date(from) - new Date(task?.startingDate)) / (1000 * 60 * 60 * 24);
        let leftDays = moment
          .utc(new Date(from))
          .diff(moment.utc(new Date(task?.startingDate)), "days");
        let left = (Math.abs(leftDays) / 63) * 95.7;
        let isLarger = moment
          .utc(new Date(from))
          .isAfter(moment.utc(new Date(task?.endDate)));
        task["width"] = `${width}%`;
        task["left"] =
          new Date(from) > new Date(task?.startingDate)
            ? `-${left}%`
            : `${left}%`;
        task["display"] = isLarger ? `none` : `flex`;
      } else {
        task["display"] = "none";
      }
    });
    return tasks;
  };

  const getTotalWeeks = (weekNumber, year, totalWeeks) => {
    let weeks = [];
    let number = weekNumber;
    let y = year;
    for (let i = 0; i <= 8; i++) {
      let obj = {};
      obj["weekNumber"] = number;
      obj["year"] = y;
      obj["weekDays"] = getDaysOfWeek(y, number);
      if (number < totalWeeks) number++;
      else {
        number = 1;
        y += 1;
      }
      weeks.push(obj);
    }
    return weeks;
  };

  // ASC for week dates start
  const [startWeek, setStartWeek] = useState(
    moment().startOf("isoWeek").format()
  );
  const [endWeek, setEndWeek] = useState(moment().endOf("isoWeek").format());

  let startDate = moment(startWeek).format();
  let endDate = moment(endWeek).format();
  // ASC for week dates end

  const addEquipmentToTask = async (taskid, equipmentid) => {
    const resp = await simpleRequest(`/api/User/AddEquipmentToTask`, "post", {
      taskid,
      equipmentid,
    });
    if (resp?.status === true) {
      fetchWorkList();
      setActiveWeek(null);
      setShowVehicle(false);
      dispatch(
        FetchEquipmentByWeek(
          companyId,
          // moment(from).toISOString(),
          // moment(from).add(63, "days").toISOString()
          startDate,
          endDate
        )
      );
    }
  };

  const onDragEnd = (result) => {
    if (result?.destination === null) return;
    if (result?.destination?.droppableId === result?.source?.droppableId)
      return;
    let workIndex = null;
    let taskIndex = null;
    for (let i = 0; i < workTasks?.length; i++) {
      taskIndex = workTasks[i]?.workTasks?.findIndex(
        (item) => item?.taskid === result?.destination?.droppableId
      );
      if (taskIndex >= 0) {
        workIndex = i;
        break;
      }
    }
    if (result?.source?.droppableId === "654321") {
      const item = workTasks[workIndex]?.workTasks[
        taskIndex
      ]?.teamdetails?.find((item) => item?.teamid === result?.draggableId);
      if (item) return;
      let mainList = [{ teamid: result?.draggableId }];
      return addAssignee(
        workTasks[workIndex]?.workTasks[taskIndex]?.taskid,
        mainList
      );
    } else {
      const updatedData = [...availableEquipmntData];
      const [draggedItem] = updatedData.splice(result.source.index, 1);
      updatedData.splice(result.destination.index, 0, draggedItem);
      setAvailableEquipmntData(updatedData);
      addEquipmentToTask(
        workTasks[workIndex]?.workTasks[taskIndex]?.taskid,
        result?.draggableId
      );
    }
  };

  const [forMutedArray, setForMutedArray] = useState([]);

  const addAssignee = async (taskId, list) => {
    const resp = await simpleRequest(`/api/User/AddTaskToTeam`, "post", {
      taskid: taskId,
      teams: list,
    });
    if (resp?.status === true) {
      fetchWorkList();
      dispatch(FetchUsersByCompany(companyId, 0, 0));
      dispatch(FetchTeams());
      let newList = new Array();
      list?.map((item) => newList.push({ assigneeid: item?.teamid }));
      setSelectedAssignees((asi) => [...newList, ...asi]);
    }
  };

  const assignTeam = () => {
    if (selectedMembers?.length > 0) {
      let list = [];
      selectedMembers?.map((id) => {
        let obj = {};
        obj["teamid"] = id;
        list.push(obj);
      });
      return addAssignee(activeTask, list);
    }
    if (selectedTeams?.length > 0) {
      let list = [];
      selectedTeams?.map((id) => {
        let obj = {};
        obj["teamid"] = id;
        list.push(obj);
      });
      return addAssignee(activeTask, list);
    }
  };

  const removeTaskAssignee = async (taskid, assigneeid) => {
    const resp = await simpleRequest(`/api/User/RemoveTaskAssignees`, "post", {
      taskid,
      assigneeid,
    });
    if (resp?.status === true) {
      fetchWorkList();
      let list = Array.from(selectedAssignees);
      let index = list.findIndex((item) => item?.assigneeid === assigneeid);
      if (index !== false || index !== -1) list.splice(index, 1);
      setSelectedAssignees([...list]);
    }
  };

  useEffect(() => {
    if (FetchTeamProjectWiseResponse?.status === true) {
      setTaskid2(FetchTeamProjectWiseResponse?.data[0]?.taskid);
      setForMutedArray(
        FetchTeamProjectWiseResponse?.data.map((item) => item.teamdetails)
      );

      dispatch(
        FetchEquipmentByWeek(
          companyId,
          // FetchTeamProjectWiseResponse?.data[0]?.createdat,
          // FetchTeamProjectWiseResponse?.data[0]?.duedatetime
          startDate,
          endDate
        )
      );
    }
  }, [FetchTeamProjectWiseResponse, startDate, endDate]);

  useEffect(() => {
    if (fetchEquipmentByWeekRes?.status === true) {
      setAvailableEquipmntData(fetchEquipmentByWeekRes?.data);
    }
  }, [fetchEquipmentByWeekRes]);

  useEffect(() => {
    if (FetchUsersByCompanyResponse?.data?.status === true) {
      setEmployeeList(FetchUsersByCompanyResponse?.data?.data);
    }
  }, [FetchUsersByCompanyResponse]);

  useEffect(() => {
    if (FetchTeamsResponse?.status === true) {
      setTeamList(FetchTeamsResponse?.data);
    }
  }, [FetchTeamsResponse]);

  useEffect(() => {
    if (AddTaskToTeamResponse?.status === true) setActiveWeek(null);
  }, [AddTaskToTeamResponse]);

  useEffect(() => {
    if (addEquipmentToTaskRes?.status === true) setActiveWeek(null);
  }, [addEquipmentToTaskRes]);

  useEffect(() => {
    if (from) {
      let currentWeek2 = new Date(from).getWeek();
      let totalWeeks2 = weeksInYear(new Date(from).getFullYear());
      let totalWeeks = getTotalWeeks(
        currentWeek2,
        new Date(from).getFullYear(),
        totalWeeks2
      );
      setWeeksArray(totalWeeks);
      fetchWorkList();
      dispatch(
        FetchEquipmentByWeek(
          companyId,
          // totalWeeks[0]?.weekDays[0],
          // totalWeeks[8]?.weekDays[6]
          startDate,
          endDate
        )
      );
      // dispatch(
      //   FetchTeamProjectWise(projectId, totalWeeks[0]?.weekDays[0], totalWeeks[8]?.weekDays[6])
      // );
    }
  }, [from, startDate, endDate]);

  useEffect(() => {
    const week = getCurrentWeek();
    setFrom(week[0]?._d); // Start of current week
    setCurrentWeek(week[0]?.isoWeek()); // Week number, e.g. 29

    dispatch(FetchTeams());
    dispatch(FetchUsersByCompany(companyId, 0, 0));

    console.log(
      "Week days:",
      week.map((d) => d.format("YYYY-MM-DD"))
    );
  }, []);

  const currentWeekNumber = moment().isoWeek();
  const previousWeekNumber = moment().subtract(1, "week").isoWeek();

  const startingDate_Popup_Ref = useRef(null);
  const endingDate_Popup_Ref = useRef(null);

  // // ASC for week dates start
  // const [startWeek, setStartWeek] = useState(
  //   moment().startOf("isoWeek").format()
  // );
  // const [endWeek, setEndWeek] = useState(moment().endOf("isoWeek").format());

  // let startDate = moment(startWeek).format();
  // let endDate = moment(endWeek).format();
  // // ASC for week dates end

  const [startingDate, setStartingDate] = useState(new Date(startWeek));
  const [endingDate, setEndingDate] = useState(new Date(endWeek));

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);

  return (
    <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
      <div className="team-main-cont">
        <div style={{ position: "relative" }}>
          <AddWork
            setIsAddWork={setIsAddWork}
            isAddWork={isAddWork}
            fetchWorkList={fetchWorkList}
          />
        </div>
        <div
          className="available-equip-box"
          style={{ width: showVehicle ? "365px" : "3rem" }}
        >
          {!showVehicle && (
            <p className="team-avail-equip-text">
              {/* Available Equiptment */}
              {t("Available Equipment")}
            </p>
          )}
          <div
            className="team-arrow-box"
            style={{
              left: showVehicle ? "-6%" : "-48%",
              transform: showVehicle ? "rotate(270deg)" : "rotate(90deg)",
            }}
            onClick={() => setShowVehicle(!showVehicle)}
          >
            <img src={arrow} />
          </div>
          {showVehicle && (
            <div className="avail-vehicles-box">
              <div className="avail-vehicle-img-box">
                <img
                  src={SupplierIcon}
                  style={{ width: "25px", height: "25px" }}
                />
                <p
                  className="team-avail-equip-text"
                  style={{ textAlign: "center", transform: "rotate(0)" }}
                >
                  {/* Available Vehicles */}
                  {t("Availble Vehicles ")}
                </p>
              </div>
              <div className="vcl-weeks-box">
                <p>{`Week ${previousWeekNumber}`}</p>
                <p>{`Week ${currentWeekNumber}`}</p>
              </div>
              <div className="vcl-dates-box">
                {/* <img src={Calendar} alt="" /> */}
                {/* <p className="med-14-414">14 Dec 2022</p> */}

                {/* date filter start */}
                <div className="flexContainer gap-1">
                  <div
                    className="projectManagerInput ps- flexContainer"
                    id=""
                    style={{ width: "auto", border: "none" }}
                    ref={startingDate_Popup_Ref}
                  >
                    <img
                      className="calendarIcon pointer"
                      onClick={() => setCalendarIsOpen((p) => !p)}
                      src={calendar}
                      alt=""
                    />
                    <AppDatePicker
                      open={calendarIsOpen}
                      inputClassNames={"bg-transparent"}
                      // className="calender-icon-date"
                      selected={startingDate}
                      onChange={(val) => {
                        setStartingDate(val);
                        setStartWeek(val);
                        setCalendarIsOpen(false);
                      }}
                      onSelect={(d, event) => {
                        event.preventDefault();
                      }}
                      // isDisabledForFuture={true}
                      // isDisabledForPast={true}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>

                  <p className="vcl-to mx-2">to</p>

                  <div
                    className="projectManagerInput ps- flexContainer"
                    style={{ width: "auto", border: "none" }}
                    ref={endingDate_Popup_Ref}
                  >
                    <img
                      className="calendarIcon pointer"
                      onClick={() => setCalendarIsOpen2((p) => !p)}
                      src={calendar}
                      alt=""
                    />
                    <AppDatePicker
                      open={calendarIsOpen2}
                      inputClassNames={"bg-transparent"}
                      selected={endingDate}
                      onChange={(val) => {
                        setEndingDate(val);
                        setEndWeek(val);
                        setCalendarIsOpen2(false);
                      }}
                      onSelect={(d, event) => {
                        event.preventDefault();
                      }}
                      // isDisabledForFuture={true}
                      // isDisabledForPast={true}
                      minDateForPlanBoard={startingDate}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                </div>
                {/* date filter end */}
              </div>

              {/* asc drag drop star */}
              {/* <DragDropContext onDragEnd={handleDragEnd}> */}
              <Droppable droppableId="ASCindex">
                {(provider) => (
                  <div
                    className="vcl-person-box ascMainDiv"
                    ref={provider.innerRef}
                    {...provider.droppableProps}
                  >
                    {availableEquipmntData.map((item, index) => {
                      return (
                        <Draggable
                          key={item.equipmentid}
                          draggableId={item.equipmentid}
                          index={index}
                        >
                          {(provider) => (
                            <div
                              className="vcl-single-box mb-1 ascChildDiv"
                              {...provider.draggableProps}
                              {...provider.dragHandleProps}
                              ref={provider.innerRef}
                            >
                              <p>
                                {item.equipmentname
                                  ? item.equipmentname
                                  : item.platenumber}
                              </p>

                              {item.driverimage ? (
                                <img
                                  className="member-image"
                                  src={item.driverimage}
                                  alt=""
                                />
                              ) : (
                                item.driverid_d !==
                                  "00000000-0000-0000-0000-000000000000" && (
                                  <div
                                    className="team-member-abv"
                                    style={{ width: "37px", height: "37px" }}
                                  >
                                    {item?.drivername &&
                                      `${item?.drivername[0]}${item?.drivername[1]}`}
                                  </div>
                                )
                              )}
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  </div>
                )}
              </Droppable>
              {/* </DragDropContext> */}
              {/* asc drag drop end */}
            </div>
          )}
        </div>
        <div className="team-grid-box">
          <div
            className={showMemberBox ? "employeDiv" : ""}
            style={{ position: "relative", overflow: "hidden" }}
          >
            <div
              className="member-list-absolute"
              style={{ top: showMemberBox ? "0" : "-150%" }}
            >
              <div className="list-cross-box">
                <img
                  alt=""
                  src={cross2}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setActiveTask(null);
                    setShowMemberBox(false);
                    setSelectedMembers([]);
                    setSelectedTeams([]);
                  }}
                />
              </div>
              <div className="list-from-to-flex">
                <p className="med-14-7e7e">From</p>
                <p className="bold-14-333">
                  {weeksArray[0]?.weekNumber}
                  <br /> <span style={{ fontWeight: "400" }}> Week</span>
                </p>
                <p className="med-14-7e7e">To</p>
                <p className="bold-14-333">
                  {weeksArray[8]?.weekNumber.toString()?.padStart(2, "0")}{" "}
                  <br /> <span style={{ fontWeight: "400" }}> Week</span>
                </p>
              </div>
              <div className="member-sort-flex">
                <p className="med-14-7e7e">Sort by</p>
                <div style={{ position: "relative" }}>
                  <div className="sort-flex-2">
                    <p
                      className="med-14-2b1"
                      onClick={() => setShowSortBy(true)}
                    >
                      {sortBy}
                    </p>
                    <img
                      src={arrow}
                      style={{ width: "12px", height: "12px" }}
                      onClick={() => setShowSortBy(true)}
                    />
                  </div>
                  <div
                    className="sort-popup"
                    style={{ display: showSortBy ? "flex" : "none" }}
                  >
                    <div className="sort-flex-2" style={{ gap: "20px" }}>
                      <p className="med-14-D5D5">Sort By</p>
                      <img
                        src={arrow}
                        style={{
                          width: "12px",
                          height: "12px",
                          transform: "rotate(-180deg)",
                        }}
                        onClick={() => setShowSortBy(false)}
                      />
                    </div>
                    <div className="sort-flex-2" style={{ gap: "20px" }}>
                      <p
                        className="med-14-2b1"
                        onClick={() => {
                          setSortBy("Employee");
                          setShowSortBy(false);
                        }}
                      >
                        Employee
                      </p>
                    </div>
                    <div className="sort-flex-2" style={{ gap: "20px" }}>
                      <p
                        className="med-14-2b1"
                        onClick={() => {
                          setSortBy("Team");
                          setShowSortBy(false);
                        }}
                      >
                        Team
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Droppable droppableId={`654321`} key={`droppable-${654321}`}>
                {(provided, snapshot) => {
                  return (
                    <div
                      className="member-list-flex"
                      key={`droppable-div-${654321}`}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {sortBy === "Team" ? (
                        <>
                          {teamList?.map((team, index) => {
                            let isSelected = selectedAssignees.find(
                              (item) => item?.assigneeid === team?.teamid,
                            );
                            // let isSelected = forMutedArray?.some((x) =>
                            //   x.some((item) => item.teamid === team.teamid)
                            // );

                            return (
                              <Draggable
                                key={`draggable-${team?.teamid}`}
                                draggableId={team?.teamid}
                                index={index}
                                isDragDisabled={isSelected ? true : false}
                              >
                                {(provided, snapshot) => {
                                  return (
                                    <div
                                      className={
                                        isSelected === true
                                          ? "pointerNone text-muted single-member-flex"
                                          : "single-member-flex"
                                      }
                                      key={team?.teamid}
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div className="member-image-text">
                                        {team?.teamLogo ? (
                                          <img
                                            alt=""
                                            className="member-image"
                                            src={team?.teamLogo}
                                          />
                                        ) : (
                                          <div className="team-member-abv">
                                            {`${team?.teamName[0]}${team?.teamName[1]}${team?.teamName[2]}`}
                                          </div>
                                        )}
                                        <div className="fc">
                                          <p
                                            className="med-14-333"
                                            style={{
                                              overflow: "hidden",
                                              maxWidth: "146px",
                                              color: isSelected
                                                ? "#a5a5a5"
                                                : "",
                                            }}
                                          >
                                            {team?.teamName} <br />
                                          </p>
                                          <p
                                            style={{
                                              color: "#7E7E7E",
                                              fontSize: "13px",
                                              fontWeight: 500,
                                            }}
                                          >
                                            {team?.membercount} Members
                                          </p>
                                        </div>
                                      </div>
                                      <div
                                        className="material-checkbox"
                                        style={{
                                          backgroundColor: selectedTeams?.find(
                                            (id) => id === team?.teamid,
                                          )
                                            ? "#95A7C6"
                                            : "transparent",
                                          boxShadow:
                                            selectedTeams?.find(
                                              (id) => id === team?.teamid,
                                            ) && "0px 3px 6px #3C476033",
                                        }}
                                        onClick={() => {
                                          let list = [...selectedTeams];
                                          let index =
                                            list?.length > 0
                                              ? list.findIndex(
                                                  (id) => id === team?.teamid,
                                                )
                                              : false;
                                          if (index === false || index === -1) {
                                            list.push(team?.teamid);
                                          } else {
                                            list.splice(index, 1);
                                          }
                                          setSelectedTeams([...list]);
                                        }}
                                      ></div>
                                    </div>
                                  );
                                }}
                              </Draggable>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          {employeeList?.map((employee, index3) => {
                            let isSelected = selectedAssignees.find(
                              (item) => item?.assigneeid === employee?.userid,
                            );
                            // let isSelected = forMutedArray?.some((team) =>
                            //   team.some((item) => item.teamid === employee.userid)
                            // );
                            return (
                              <Draggable
                                key={`draggable-${employee?.userid}`}
                                draggableId={employee?.userid}
                                index={index3}
                                isDragDisabled={isSelected ? true : false}
                              >
                                {(provided, snapshot) => {
                                  return (
                                    <div
                                      // className="single-member-flex"
                                      className={
                                        isSelected === true
                                          ? "pointerNone text-muted single-member-flex"
                                          : "single-member-flex"
                                      }
                                      key={employee?.userid}
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div className="member-image-text">
                                        {employee?.userdetails[0]?.imageurl ? (
                                          <img
                                            alt=""
                                            className="member-image"
                                            src={
                                              employee?.userdetails[0]?.imageurl
                                            }
                                          />
                                        ) : (
                                          <div className="team-member-abv">
                                            {
                                              employee?.userdetails[0]
                                                ?.firstname[0]
                                            }
                                            {employee?.userdetails[0]?.lastname
                                              ? employee.userdetails[0]
                                                  .lastname[0]
                                              : ""}
                                          </div>
                                        )}
                                        <div className="fc">
                                          <p
                                            className="med-14-333"
                                            style={{
                                              overflow: "hidden",
                                              maxWidth: "146px",
                                              color: isSelected
                                                ? "#a5a5a5"
                                                : "",
                                            }}
                                          >
                                            {
                                              employee?.userdetails[0]
                                                ?.firstname
                                            }{" "}
                                            {employee?.userdetails[0]?.lastname
                                              ? employee.userdetails[0].lastname
                                              : ""}
                                          </p>
                                          <p
                                            style={{
                                              color: "#7E7E7E",
                                              fontSize: "13px",
                                              fontWeight: 500,
                                              marginTop: "5px",
                                            }}
                                          >
                                            {employee?.userdetails[0]?.jobpost}
                                          </p>
                                        </div>
                                      </div>
                                      <div
                                        className="material-checkbox"
                                        style={{
                                          backgroundColor:
                                            selectedMembers?.find(
                                              (id) => id === employee?.userid,
                                            ) || isSelected
                                              ? "#95A7C6"
                                              : "transparent",
                                          boxShadow:
                                            (selectedMembers?.find(
                                              (id) => id === employee?.userid,
                                            ) ||
                                              isSelected) &&
                                            "0px 3px 6px #3C476033",
                                        }}
                                        onClick={() => {
                                          let list = [...selectedMembers];
                                          let index =
                                            list?.length > 0
                                              ? list.findIndex(
                                                  (id) =>
                                                    id === employee?.userid,
                                                )
                                              : false;
                                          if (index === false || index === -1) {
                                            list.push(employee?.userid);
                                          } else {
                                            list.splice(index, 1);
                                          }
                                          setSelectedMembers([...list]);
                                        }}
                                      ></div>
                                    </div>
                                  );
                                }}
                              </Draggable>
                            );
                          })}
                        </>
                      )}
                    </div>
                  );
                }}
              </Droppable>
              <div style={{ textAlign: "center" }}>
                <button
                  className="team-apply-button"
                  onClick={() => {
                    assignTeam();
                    setShowMemberBox(false);
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
            <div className="team-grid-left-up">
              <div>
                <button
                  className="team-grid-make-task-btn"
                  onClick={() => dispatch(changeProjectTab("Work"))}
                >
                  {/* Make Tasks */}
                  {t("Make Tasks")}
                </button>
              </div>
              <div>
                <img
                  src={arrow}
                  style={{ transform: "rotate(90deg)", cursor: "pointer" }}
                  onClick={() => {
                    let weekNumber = weeksArray[0]?.weekNumber - 9;
                    let totalWeeks = weeksInYear(weeksArray[0]?.year);
                    let year = weeksArray[0]?.year;
                    if (weekNumber <= 0) {
                      weekNumber = currentWeek;
                      year = year - 1;
                    }
                    let weeks = getTotalWeeks(weekNumber, year, totalWeeks);
                    setFrom(weeks[0]?.weekDays[0]);
                    setWeeksArray(weeks);
                  }}
                />
              </div>
            </div>
            <div className="team-grid-left">
              <div
                className="team-left-taskname-box cursor-pointer"
                onClick={() => setIsAddWork(true)}
              >
                <div className="frc" style={{ gap: "8px" }}>
                  <img src={Plusicon} style={{ opacity: 0.7 }} />
                  <p className="team-left-task-text">
                    {/* Create Work */}
                    {t("Create Work")}
                  </p>
                </div>
              </div>
              <div
                className="team-left-taskname-box"
                style={{ paddingLeft: "0", justifyContent: "center" }}
              >
                <p className="team-left-task-text">
                  {/* Start Date */}
                  {t("Start Date")}
                </p>
              </div>
            </div>
            {workTasks?.map((work, index) => {
              return (
                <div className="team-grid-left" key={index}>
                  <div
                    className="team-left-taskname-box"
                    style={{ padding: "5px 3px 5px 12px" }}
                  >
                    <div className="fc" style={{ gap: "5px" }}>
                      <p
                        className="team-left-work-name-text"
                        style={{
                          // for 3 dots 👇
                          // whiteSpace: "pre-wrap",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "160px",
                        }}
                        title={work?.workname}
                      >
                        {work?.workname}
                      </p>
                      <div
                        className="fc"
                        style={{ paddingLeft: "1rem", gap: "5px" }}
                      >
                        {work?.workTasks?.map((task, i) => {
                          return (
                            <p
                              className="team-left-task-text"
                              key={i}
                              style={{
                                // for 3 dots 👇
                                // whiteSpace: "pre-wrap",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "160px",
                                ///////////////////
                                fontWeight: 500,
                              }}
                              title={task?.taskname}
                            >
                              {task?.taskname}
                              {/* {task?.taskname?.length > 20
                                ? task?.taskname?.slice(0, 20) + "..."
                                : task?.taskname} */}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div
                    className="team-left-taskname-box"
                    style={{ paddingLeft: "0", justifyContent: "center" }}
                  >
                    <div className="fc" style={{ gap: "5px" }}>
                      <p
                        className="team-left-task-text"
                        style={{ fontWeight: "500", opacity: 0 }}
                      >
                        {moment(work?.date).format("DD/MM/YYYY")}
                      </p>
                      {work?.workTasks?.map((task, i) => {
                        return (
                          <p
                            className="team-left-task-text"
                            style={{ fontWeight: "500" }}
                            key={i}
                          >
                            {moment
                              .utc(new Date(task?.startingDate))
                              .local()
                              .format("DD/MM/YYYY")}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ position: "relative", overflow: "hidden" }}>
            <div
              className="absolute-weekdays"
              style={{
                left: activeWeekIndex ? `${10.625 * +activeWeekIndex}%` : "0",
                top: activeWeek ? "0%" : "-42%",
              }}
            >
              <div className="team-grid-weekdays">
                <p className="active-week-text">
                  Week{" "}
                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: "clamp(14px,1.025vw,1.025vw)",
                    }}
                  >
                    {activeWeek}
                  </span>
                </p>
                <img
                  src={cross}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setActiveWeek(null);
                    const list = Array.from(workTasks);
                    list.forEach((item) => {
                      item["workTasks"] = getTasksPosition(
                        undefined,
                        undefined,
                        undefined,
                        item?.workTasks,
                      );
                    });
                    setWorkTasks([...list]);
                  }}
                />
              </div>
              <div className="week-days-grid-7">
                {activeWeekList?.map((day, index) => {
                  let NumbersOfDays = new Date(day).getDay();
                  const daysOfWeek = [
                    "Sun",
                    "Mon",
                    "Tue",
                    "Wed",
                    "Thu",
                    "Fri",
                    "Sat",
                  ];
                  const dayName = daysOfWeek[NumbersOfDays];
                  return (
                    <div
                      className="team-left-taskname-box single-day"
                      key={index}
                    >
                      <p
                        style={{
                          fontWeight: "700",
                          fontSize: "clamp(14px,1.025vw,1.025vw)",
                        }}
                      >
                        {new Date(day).getDate()}
                      </p>
                      <p style={{ fontSize: "clamp(13px,0.952vw, 0.952vw)" }}>
                        {/* Day */}
                        {dayName}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="team-grid-right-up">
              {weeksArray?.map((week, index) => {
                return (
                  <div
                    key={index}
                    className="active-date-div"
                    style={{
                      backgroundColor:
                        currentWeek !== week?.weekNumber && "transparent",
                      transitionDuration: "600ms",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (index === 0 || index === 1) setActiveWeekIndex(index);
                      if (index >= 2) setActiveWeekIndex(2);
                      setActiveWeek(week?.weekNumber);
                      setActiveWeekList(weeksArray[index]?.weekDays);
                      const list = Array.from(workTasks);
                      list.forEach((item) => {
                        item["workTasks"] = getTasksPosition(
                          index,
                          week,
                          weeksArray[index]?.weekDays,
                          item?.workTasks,
                        );
                      });
                      setWorkTasks([...list]);
                    }}
                  >
                    <p
                      className="mb-0 active-date-top"
                      style={{
                        fontSize: "clamp(14px,0.729vw,0.729vw)",
                        fontWeight: "bold",
                        transitionDuration: "600ms",
                        color: currentWeek !== week?.weekNumber && "#333333",
                      }}
                    >
                      {week?.weekNumber.toString().padStart(2, "0")}
                    </p>
                    <p
                      className="mb-0 active-week-bottom"
                      style={{
                        backgroundColor:
                          currentWeek !== week?.weekNumber && "transparent",
                        color: currentWeek !== week?.weekNumber && "#333333",
                        transitionDuration: "600ms",
                      }}
                    >
                      Week
                    </p>
                  </div>
                );
              })}
              <div className="team-right-arrow">
                <img
                  src={arrow}
                  style={{ transform: "rotate(-90deg)", cursor: "pointer" }}
                  onClick={() => {
                    let totalWeeks = weeksInYear(weeksArray[8]?.year);
                    let weeks = getTotalWeeks(
                      weeksArray[8]?.weekNumber + 1,
                      weeksArray[8]?.year,
                      totalWeeks,
                    );
                    setFrom(weeks[0]?.weekDays[0]);
                    setWeeksArray(weeks);
                  }}
                />
              </div>
            </div>
            <div className="team-grid-right">
              {emptyBox.map((_, i) => {
                return <div className="team-left-taskname-box" key={i}></div>;
              })}
            </div>
            {workTasks?.map((work, index) => {
              return (
                <SingleWorkLine
                  work={work}
                  emptyBox={emptyBox}
                  setShowMemberBox={setShowMemberBox}
                  setActiveTask={setActiveTask}
                  key={index}
                  setSelectedAssignees={setSelectedAssignees}
                  removeTaskAssignee={removeTaskAssignee}
                />
              );
            })}
          </div>
        </div>
      </div>
    </DragDropContext>
  );
};

export default Team;
